function hasCaseableLetters(value: string): boolean {
  return Array.from(value).some((character) => character.toLocaleLowerCase() !== character.toLocaleUpperCase());
}

function usesUniformLetterCase(value: string): boolean {
  if (!hasCaseableLetters(value)) return false;
  return value === value.toLocaleLowerCase('en-AU') || value === value.toLocaleUpperCase('en-AU');
}

export function normalizePersonNameCase(value: unknown): string {
  const normalized = String(value ?? '').replace(/\s+/g, ' ').trim();
  if (!normalized) return '';

  const source = usesUniformLetterCase(normalized)
    ? normalized.toLocaleLowerCase('en-AU')
    : normalized;

  return source.replace(/(^|[\s\-'’])(\p{L})/gu, (_match, prefix: string, letter: string) => (
    `${prefix}${letter.toLocaleUpperCase('en-AU')}`
  ));
}
